import { Position } from '@xyflow/react';
import { ERFElement } from '../../../enums';
import { L_FLOW_HEX, M_FLOW_HEX } from '../../../constants';
export const COKER_R_CONFIG = {
    type: ERFElement.CokerRBlock,
    icon: 'CokerRBlock_2d',
    templates: [
        {
            code: 'default',
            ports: [
                {
                    id: 'target_material_flow',
                    type: 'target',
                    name: 'Сырьё',
                    position: Position.Left,
                    style: { top: 161, left: 8, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_material_product_flow',
                    type: 'source',
                    name: 'Газы коксования',
                    position: Position.Right,
                    style: { top: 14, right: 8, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                /* PORTS FOR LOGICAL ELEMENTS */
                {
                    id: 'target_logical_flow',
                    type: 'target',
                    name: 'Входные параметры',
                    position: Position.Left,
                    style: { top: 178, left: 8, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                },
                {
                    id: 'source_logical_flow',
                    type: 'source',
                    name: 'Выходные параметры',
                    position: Position.Right,
                    style: { top: 178, right: 8, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                }
            ]
        }
    ]
};
//# sourceMappingURL=RFCokerRNode.config.js.map